/** Returns true when the props are of type {@link DayPickerRangeProps}. */
export function isDayPickerRange(props) {
    return props.mode === 'range';
}
//# sourceMappingURL=DayPickerRange.js.map